import AdjustmentsTasksList from './AdjustmentsTasksList';

export default AdjustmentsTasksList;
